<script>
import { mapActions, mapMutations } from 'vuex'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { SweetModal } from 'sweet-modal-vue'
import VuePdfApp from 'vue-pdf-app'
import { id } from 'vuejs-datepicker/dist/locale'
import mixinHelper from '@/mixins/helper'
import 'vue-pdf-app/dist/icons/main.css'

export default {
   name: 'LaporanOss',
   components: {
      BCardCode,
      SweetModal,
      VuePdfApp,
   },
   mixins: [mixinHelper],
   data() {
      return {
         pdf: '',
         loading: true,
         loadingPdf: false,
         filterDateValue: new Date(),
         filterDateLang: id,
         form: {
            tanggal: null,
            kbli: 93210,
            triwulan: {
               triwulan: null,
               tahun: null,
               jenis: 'Baru',
            },
         },
         options: {
            triwulan: [
               { value: null, text: 'Pilih triwulan' },
               { value: 'I', text: 'I' },
               { value: 'II', text: 'II' },
               { value: 'III', text: 'III' },
               { value: 'IV', text: 'IV' },
            ],
            jenis: [
               { value: null, text: 'Pilih jenis data' },
               { value: 'Baru', text: 'Baru' },
               { value: 'Baru & Perubahan', text: 'Baru & Perubahan' },
            ],
         },
      }
   },
   watch: {
      loadingPdf(val) {
         if (val) {
            this.$swal({ text: 'Loading', allowOutsideClick: false })
            this.$swal.showLoading()
         } else {
            this.$swal.close()
         }
      },
      'form.triwulan.tahun': function _(newVal) {
         this.form.triwulan.tahun = this.convertDate2Year(newVal)
      },
   },
   methods: {
      ...mapActions({
         cetakLaporan: 'OssNib/cetakLaporan',
         cetakLaporanTriwulan: 'OssNib/cetakLaporanTriwulan',
         cetakLaporanKbli: 'OssNib/cetakLaporanKbli',
      }),
      ...mapMutations({
         setIdProyek: 'OssBidangUsaha/SET_ID_PROYEK',
      }),
      myFilter() {
         // const d = new Date(this.filterDateValue)
         // const filterDateValue = this.$moment(d).format('YYYY-MM-DD')

         // this.form.tanggal = this.filterDateValue
         console.log('tanggal', this.form.tanggal)
      },
      onCetakLaporan() {
         this.loadingPdf = true
         this.cetakLaporan(this.form.tanggal).then(
            res => {
               const blob = new Blob([res.data])
               this.pdf = URL.createObjectURL(blob)
               // URL.revokeObjectURL(objectURL)
               this.$refs.modalPdf.open()
               this.loadingPdf = false
            },
            () => {
               this.loadingPdf = false
            },
         )
      },
      onCetakLaporanTriwulan() {
         this.loadingPdf = true
         this.cetakLaporanTriwulan(this.form.triwulan).then(
            res => {
               const blob = new Blob([res.data])
               this.pdf = URL.createObjectURL(blob)
               // URL.revokeObjectURL(objectURL)
               this.$refs.modalPdf.open()
               this.loadingPdf = false
            },
            () => {
               this.loadingPdf = false
            },
         )
      },
      onCetakLaporanKbli() {
         this.loadingPdf = true
         this.cetakLaporanKbli(this.form).then(
            res => {
               const blob = new Blob([res.data])
               this.pdf = URL.createObjectURL(blob)
               // URL.revokeObjectURL(objectURL)
               this.$refs.modalPdf.open()
               this.loadingPdf = false
            },
            () => {
               this.loadingPdf = false
            },
         )
      },
   },
}
</script>

<template>
   <div>
      <b-row>
         <b-col cols="12" lg="6">
            <b-card-code title="Laporan Harian" class="mb-2">
               <b-row>
                  <b-col cols="12">
                     <b-form-group>
                        <datepicker
                           id="tanggal"
                           v-model="form.tanggal"
                           input-class="datepicker-here form-control rounded-lg"
                           minimum-view="date"
                           maximum-view="year"
                           format="dd MMMM yyyy"
                           :language="filterDateLang"
                           placeholder="Pilih tanggal"
                           @input="myFilter"
                        />
                        <small class="text-muted">Pilih tanggal untuk mencetak laporan harian.</small>
                     </b-form-group>
                     <b-button variant="primary" class="rounded-pill px-4 mb-1" @click="onCetakLaporan">
                        Cetak
                     </b-button>
                  </b-col>
               </b-row>
            </b-card-code>

            <b-card-code title="KBLI" class="mb-2 mb-lg-0">
               <b-row>
                  <b-col cols="12">
                     <b-form-group>
                        <b-form-input
                           id="kbli"
                           v-model="form.kbli"
                           type="text"
                           name="kbli"
                           autocomplete="off"
                           placeholder="Masukkan KBLI"
                           class="rounded-lg"
                        />
                        <small class="text-muted">Masukkan kode KBLI untuk mencetak laporan.</small>
                     </b-form-group>
                     <b-button variant="primary" class="rounded-pill px-4 mb-1" @click="onCetakLaporanKbli">
                        Cetak
                     </b-button>
                  </b-col>
               </b-row>
            </b-card-code>
         </b-col>

         <b-col cols="12" lg="6">
            <b-card-code title="Laporan Triwulan" class="mb-2 mb-lg-0">
               <b-row>
                  <b-col cols="12">
                     <b-form-group>
                        <datepicker
                           id="tahun"
                           v-model="form.triwulan.tahun"
                           :minimum-view="'year'"
                           :maximum-view="'year'"
                           format="yyyy"
                           input-class="datepicker-here form-control rounded-lg"
                           placeholder="Pilih tahun"
                        />
                        <small class="text-muted">Pilih tahun laporan.</small>
                     </b-form-group>
                     <b-form-group>
                        <b-form-select v-model="form.triwulan.jenis" :options="options.jenis" class="rounded-lg" />
                        <small class="text-muted">Pilih jenis data laporan.</small>
                     </b-form-group>
                     <b-form-group>
                        <b-form-select v-model="form.triwulan.triwulan" :options="options.triwulan" class="rounded-lg" />
                        <small class="text-muted">Pilih periode triwulan.</small>
                     </b-form-group>
                     <b-button variant="primary" class="rounded-pill px-4 mb-1" @click="onCetakLaporanTriwulan">
                        Cetak
                     </b-button>
                  </b-col>
               </b-row>
            </b-card-code>
         </b-col>
      </b-row>

      <sweet-modal ref="modalPdf" modal-theme="light" overlay-theme="dark" width="80%">
         <!-- <pdf :src="pdf" /> -->
         <div style="height: 70vh">
            <vue-pdf-app :pdf="pdf" />
         </div>
      </sweet-modal>
   </div>
</template>

<style scoped>
.borderless>tr>td {
   border: none;
   padding: 0em;
}

table>tbody>tr>td>span>hr {
   margin-top: 0rem;
   margin-bottom: 0rem;
}

.nowrap {
   white-space: nowrap;
}
</style>
